import { useLocation } from '@lingoda/router';
import { getStorageValue } from '@lingoda/utils';
import { STORAGE_KEY_INITIAL_IS_IN_TRIAL } from '../constants';
import {
    getActiveSurveySteps,
    getOnboardingStepByPathname,
    getOnboardingTotalSteps,
} from '../onboardingSteps';
import { useIsOnboardingM2PledgeEnabled } from './useIsOnboardingM2PledgeEnabled';
import { useIsOnboardingReworkEnabled } from './useIsOnboardingReworkEnabled';

export const useOnboardingStepCounter = () => {
    const { pathname } = useLocation();
    const { isEnabled } = useIsOnboardingReworkEnabled();
    const { isPledgeEnabled } = useIsOnboardingM2PledgeEnabled();
    const isInTrial = !!getStorageValue(STORAGE_KEY_INITIAL_IS_IN_TRIAL);
    const surveyStepCount = getActiveSurveySteps(isPledgeEnabled).length;

    const currentStep = isEnabled
        ? getOnboardingStepByPathname(pathname, isInTrial, surveyStepCount)
        : null;

    if (currentStep === null) {
        return null;
    }

    return { currentStep, totalSteps: getOnboardingTotalSteps(isInTrial, surveyStepCount) };
};
